import React, { Component } from 'react';
import Counter from '../Counter';
import { Link } from 'react-router-dom';


class SiteContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iconbox: [],
            loading: true,
            error: null,
            history: [
                {
                    id: 1,
                    content: [
                        {
                            id: 1,
                            year: '2000',
                            text: 'Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits der Standard Demo Text seit 1500',
                            classnames: "flat-content-wrap",
                        },
                        {
                            id: 2,
                            year: '2010',
                            text: 'Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits der Standard Demo Text seit 1500',
                            classnames: "flat-content-wrap",
                        },
                    ]
                },
                {
                    id:2,
                    content: [
                        {
                            id: 3,
                            year: '2005',
                            text: 'Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits der Standard Demo Text seit 1500',
                            classnames: "flat-content-wrap pd26",
                        },
                        {
                            id: 4,
                            year: '2018',
                            text: 'Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits der Standard Demo Text seit 1500',
                            classnames: "flat-content-wrap pd26",
                        },
                    ]
                }             
            ],
            accordions: [
                {
                    id: 1,
                    classnames: 'accordion-item active',
                    title: 'OUR MISSION',
                    text: 'To deliver construction projects with consistent quality, clear timelines, and cost efficiency. We focus on practical execution, strong coordination, and attention to detail to ensure every project meets client expectations and performs reliably over time.'
                },
                {
                    id: 2,
                    classnames: 'accordion-item',
                    title: 'OUR VISION',
                    text: 'To become a trusted name in the construction industry by building long-term client relationships and delivering projects that stand for quality, durability, and accountability across every segment we serve.'
                },
                {
                    id: 3,
                    classnames: 'accordion-item',
                    title: 'OUR TECHNOLOGY',
                    text: 'We use modern construction methods, project management tools, and efficient planning systems to improve accuracy, reduce delays, and maintain better control over execution. This allows us to deliver projects with greater consistency and transparency.'
                }
            ]
        }
    }

    componentDidMount() {
        this.fetchIconBoxData();
    }

    fetchIconBoxData = async () => {
        try {
            this.setState({ loading: true, error: null });

            // Use environment variable with fallback to localhost for development
            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
            const apiUrl = `${baseUrl}/api/ourFeature/active`;

            const response = await fetch(apiUrl);


            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();

            
            if (result.success && Array.isArray(result.data)) {
                this.setState({
                    iconbox: result.data,
                    loading: false
                });
            } else {
                throw new Error('Invalid data format from API');
            }
            
        } catch (error) {
            console.error('Error fetching iconbox data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    renderIconBoxContent() {
        const { iconbox, loading, error } = this.state;

        if (loading) {
            return (
                <div className="col-12 text-center">
                    <div className="loading-spinner">Loading companies...</div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="col-12 text-center">
                    <div className="error-message">
                        Error loading companies: {error}
                        <button onClick={this.fetchIconBoxData} className="retry-btn">
                            Retry
                        </button>
                    </div>
                </div>
            );
        }

        if (!iconbox || iconbox.length === 0) {
            return (
                <div className="col-12 text-center">
                    <div className="no-data">No companies available</div>
                </div>
            );
        }

        return iconbox.map(data => (
            <div className="col span_1_of_4" key={data._id || data.id}>
                <div className="themesflat-content-box clearfix" data-margin="0 0px 0 0px" data-mobilemargin="0 0 0 0">
                    <div
                        className="themesflat-icon-box icon-top align-center has-width w95 circle light-bg accent-color border-light padding-inner pd33 style-1 clearfix">
                        <div className="icon-wrap">
                            <i className={data.icon} />
                        </div>
                        <div className="text-wrap">
                            <h5 className="heading"><Link to="#">{data.title}</Link></h5>
                            <div className="sep clearfix" />
                            <p className="sub-heading">{data.text}</p>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    render() {
        return (
            <div id="site-content" className="site-content clearfix">
                <div id="inner-content" className="inner-content-wrap">
                    <div className="themesflat-spacer clearfix" data-desktop={61} data-mobile={60} data-smobile={60} />
                    <div className="themesflat-headings style-2 clearfix py-2">
                        <h2 className="heading">ABOUT COMPANY</h2>
                        <div className="sep has-width w80 accent-bg clearfix" />
                        <p className="sub-heading line-height-24 text-777 margin-top-28 margin-right-12">We are a dedicated construction company focused on delivering reliable, high-quality projects across residential, commercial, and infrastructure sectors. With a practical approach to planning and execution, we ensure every project is handled with clarity, efficiency, and attention to detail.

Our team works closely with clients to understand requirements, manage resources effectively, and maintain strict quality and safety standards throughout the construction process. From initial planning to final delivery, we aim to create structures that are not only functional but also built for long-term performance.

By combining on-ground experience with structured project management, we continue to deliver results that meet timelines, control costs, and maintain consistent quality across every project.</p>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={28} data-mobile={35} data-smobile={35} />
                    <div 
  className="themesflat-row gutter-15 clearfix" 
  style={{ padding: '20px 0' }}
>
  {this.renderIconBoxContent()}
</div>

<div className="themesflat-spacer clearfix" data-desktop={45} data-mobile={35} data-smobile={35} />



                         <Counter  className="py-1"/>


                    {/* <div className="themesflat-spacer clearfix" data-desktop={45} data-mobile={35} data-smobile={35} /> */}
                    {/* <div className="themesflat-headings style-2 clearfix">
                        <h2 className="heading">OUR HISTORY</h2>
                        <div className="sep has-width w80 accent-bg clearfix" />
                    </div> */}
                    {/* <div className="themesflat-spacer clearfix" data-desktop={24} data-mobile={35} data-smobile={35} /> */}
                    {/* <div className="themesflat-row separator drank clearfix">
                        {
                            this.state.history.map(data => (
                                <div className="span_1_of_6 separator-solid" key={data.id}>
                                    {
                                        data.content.map(contents => (
                                            <div className={contents.classnames} key={contents.id}>
                                                <div className="title">{contents.year}</div>
                                                <p>{contents.text}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div> */}
                    <div className="themesflat-spacer clearfix" data-desktop={38} data-mobile={35} data-smobile={35} />
             
<div className="themesflat-headings style-2 clearfix text-center">
  <h2 className="heading">OUR CORE VALUES</h2>
  {/* <div className="sep has-width w80 accent-bg clearfix" /> */}
</div>

<div className="themesflat-spacer clearfix" data-desktop={35} data-mobile={35} data-smobile={35} />

<div
  className="themesflat-content-box container"
  data-margin="0 0 0 0"
  data-mobilemargin="0 0 0 0"
>
  <div className="row justify-content-center">
    {this.state.accordions.map((data) => (
      <div
        className="col-md-4 col-sm-12 d-flex"
        key={data.id}
        style={{
          marginBottom: "20px",
        }}
      >
        <div
          className={`${data.classnames} w-100`}
          style={{
            border: "1px solid #ddd",
            borderRadius: "10px",
            padding: "20px",
            backgroundColor: "#fff",
            flex: 1,
          }}
        >
          <h3
            className="accordion-heading"
            style={{ fontSize: "18px", fontWeight: 600 }}
          >
            <span className="inner">{data.title}</span>
          </h3>
          <div className="accordion-content">
            <div style={{ marginTop: "10px", color: "#555" }}>{data.text}</div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

                    <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={60} data-smobile={60} />
                </div>
            </div>
        );
    }
}

export default SiteContent;